import {
    SENDINGDATA,
    SEARCHINGSKU,
    SEARCHINGSKUGALERIA,
    DADOSGALERIA,
    URLSVITRINE,
    CODPARCVITRINESEARCH,
    CRIAVITRINELOADING,
    NOVOCLIENTE_CHANGETAB,
    LASTSKUSEACRH,
    LISTAPROVACAO,
    APROVACAOSENDLOADING,
    LISTAPROVACAOLOADING,
    ATRIBUTOSLISTLOADING,
    ATRIBUTOSLIST,
    ATRIBUTOSITEMLISTLOADING,
    ATRIBUTOSITEMLIST,
    DELETEATRIBUTOSITEMLISTLOADING,
    DELETEATRIBUTOSITEMLIST,
    POSTATRIBUTOADDNEWLOADING,
    POSTATRIBUTOADDNEW,
    DELETEATRIBUTOLOADING,
    DELETEATRIBUTO,
    EDITATRIBUTOLOADING,
    EDITATRIBUTO,
    CHANGETAB,
    SET_ATRIBUTO_SELECIONADO,
    ATRIBUTOSAPLICARLISTLOADING,
    ATRIBUTOSAPLICARLIST,
    ATRIBUTOSAPLICARGERAL,
    ATRIBUTOSAPLICARGERALLOADING,
    ATRIBUTOSAPLICAREDIT,
    ATRIBUTOSAPLICAREDITLOADING,
    ATRIBUTOSAPLICARDELETE,
    ATRIBUTOSAPLICARDELETELOADING,
    FABRICANTELISTLOADING,
    FABRICANTELIST,
    CLASSIFICACAOLISTLOADING,
    CLASSIFICACAOLIST,
    MARCALISTLOADING,
    MARCALIST,
    LINHALISTLOADING,
    LINHALIST,
    SECAOLIST,
    SECAOLISTLOADING,
    CONTEUDOLISTLOADING,
    CONTEUDOLIST,
    CONTEUDOBUSCA,
    CONTEUDOBUSCALOADING,
    CONTEUDOAPLICALOADING,
    CONTEUDOAPLICA,
    SECAOSKULISTLOADING,
    SECAOSKULIST,
    UPDATEDESCCONTEUDOLOADING,
    UPDATEDESCCONTEUDO,
    UPDATETITULOCONTEUDO,
    UPDATETITULOCONTEUDOLOADING,
    ADDTITULOCONTEUDO,
    ADDTITULOCONTEUDOLOADING,
    DELETETITULOCONTEUDO,
    DELETETITULOCONTEUDOLOADING,
    CONTEUDODETALHES,
    CONTEUDODETALHESLOADING,
    BUSCASKU,
    BUSCASKULOADING,
    BUSCASKULASTSKU,
    APLICARESTLISTLOADING,
    APLICARESTLIST,
    APLICARESTBUSCALIST,
    APLICARESTBUSCALISTLOADING,
    APLICARESTAPLICA,
    APLICARESTAPLICALOADING
} from '../actions/ActionsTypes';
import { v4 as uuidv4 } from 'uuid';
import * as Api from '../utils/API';


export const SearchSKUAction = (sku) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: SEARCHINGSKU, payload: true });

        Api.getSearchSku(sku).then(dados => {
            // dispatch({ type: ESPACOTRACK_LIST, payload: dados })
            // console.log(dados)
            dispatch({ type: SEARCHINGSKU, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });


export const SaveUploadImgAction = (dados, files, onProgress) => async (dispatch) => {
    dispatch({ type: SENDINGDATA, payload: true });
    try {
        const uploadId = uuidv4();
        let completed = 0;

        // 🔹 Mapeia todos os arquivos para promessas de upload
        const uploadPromises = files.map(async (file, index) => {
            const ext = file.name.split('.').pop().toLowerCase();
            const renamedFileName = `${dados.sku}_${index + 1}.${ext}`;
            const renamedFile = new File([file], renamedFileName, { type: file.type });

            // Obter presigned URL
            const { uploadUrl, fileUrl } = await Api.postGetPresigned({
                fileName: renamedFileName,
                fileType: file.type,
                sku: dados.sku,
                index: index + 1
            });

            // Upload para S3
            await fetch(uploadUrl, {
                method: 'PUT',
                body: renamedFile,
                headers: { 'Content-Type': file.type }
            });

            // Enviar para SQS
            await Api.postURLToSQS({
                uploadId,
                fileUrl,
                sku: dados.sku,
                userid: dados.userid,
                codparc: dados.codparc,
                observation: dados.observation,
                fileType: file.type
            });

            // Atualiza contador/progresso
            completed += 1;
            if (onProgress) onProgress(completed, files.length);
        });

        // Executa todos em paralelo
        await Promise.all(uploadPromises);

        dispatch({ type: SENDINGDATA, payload: false });
        return 'OK';
    } catch (err) {
        console.error('Erro ao enviar arquivos:', err);
        dispatch({ type: SENDINGDATA, payload: false });
        throw err;
    }
};


export const SearchSKUgaleriaAction = (sku) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: SEARCHINGSKUGALERIA, payload: true });
        dispatch({ type: LASTSKUSEACRH, payload: sku });

        // console.log(sku)
        Api.getSearchSkuGaleria(sku).then(dados => {
            // dispatch({ type: ESPACOTRACK_LIST, payload: dados })
            dispatch({ type: SEARCHINGSKUGALERIA, payload: false });
            dispatch({ type: DADOSGALERIA, payload: dados });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const GaleriaLikeAction = (entidade) => (dispatch) =>
    new Promise(function (resolve, reject) {
        Api.postGaleriaLike(entidade).then(dados => {
            console.log(dados)
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });


export const GaleriaCheckboxVitrineAction = (idmidia) => (dispatch) =>
    new Promise((resolve) => {
        dispatch({ type: URLSVITRINE, payload: idmidia });
        resolve('Ok');
    });


export const SearchCodparcAction = (codparc) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: CODPARCVITRINESEARCH, payload: true });
        Api.getSearchCodparc(codparc).then(dados => {
            dispatch({ type: CODPARCVITRINESEARCH, payload: false })
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const CriarVitrineAction = (entidade) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: CRIAVITRINELOADING, payload: true });

        Api.postVitrineCria(entidade).then(dados => {
            dispatch({ type: CRIAVITRINELOADING, payload: false })
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });




export const novoClienteChangeTabAction = (posicao) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: NOVOCLIENTE_CHANGETAB, payload: posicao })
        resolve([])
    }
    );

export const changeTabAction = (posicao) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: CHANGETAB, payload: posicao })
        resolve([])
    }
    );

export const AprovacaoListAction = (entidade) => (dispatch) =>
    new Promise(function (resolve, reject) {

        dispatch({ type: LISTAPROVACAOLOADING, payload: true });
        Api.getAprovacaoList(entidade).then(dados => {
            dispatch({ type: LISTAPROVACAOLOADING, payload: false });
            dispatch({ type: LISTAPROVACAO, payload: dados });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const AprovacaoAprovaAction = (entidade) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: APROVACAOSENDLOADING, payload: true });
        Api.postAprovacaoAprova(entidade).then(dados => {
            dispatch({ type: APROVACAOSENDLOADING, payload: false });
            dispatch({ type: LISTAPROVACAO, payload: dados });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const getAtributosListAction = (entidade) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: ATRIBUTOSLISTLOADING, payload: true });
        Api.getAtributosList(entidade).then(dados => {
            dispatch({ type: ATRIBUTOSLISTLOADING, payload: false });
            dispatch({ type: ATRIBUTOSLIST, payload: dados });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const getAtributosItemListAction = (entidade) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: ATRIBUTOSITEMLISTLOADING, payload: true });
        Api.getAtributosItem(entidade).then(dados => {
            dispatch({ type: ATRIBUTOSITEMLISTLOADING, payload: false });
            dispatch({ type: ATRIBUTOSITEMLIST, payload: dados });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const deleteAtributosItemListAction = (atributovalorid, atributoid) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: DELETEATRIBUTOSITEMLISTLOADING, payload: true });
        Api.deleteAtributosList(atributovalorid, atributoid).then(dados => {
            dispatch({ type: DELETEATRIBUTOSITEMLISTLOADING, payload: false });
            dispatch({ type: DELETEATRIBUTOSITEMLIST, payload: dados });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const editAtributoAction = (atributovalorid, atributoid, atributovalor) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: EDITATRIBUTOLOADING, payload: true });
        Api.editAtributo(atributovalorid, atributoid, atributovalor).then(dados => {
            dispatch({ type: EDITATRIBUTOLOADING, payload: false });
            dispatch({ type: EDITATRIBUTO, payload: dados });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const deleteAtributoAction = (atributovalorid, atributoid) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: DELETEATRIBUTOSITEMLISTLOADING, payload: true });
        Api.deleteAtributo(atributovalorid, atributoid).then(dados => {
            dispatch({ type: DELETEATRIBUTOLOADING, payload: false });
            dispatch({ type: DELETEATRIBUTO, payload: dados });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const postAtributoValorNewAction = (atributoid, atributovalor) => (dispatch) =>
    new Promise(function (resolve, reject) {
        console.log('entrou aqui no action')
        dispatch({ type: POSTATRIBUTOADDNEWLOADING, payload: true });
        Api.postAtributoValorNew(atributoid, atributovalor).then(dados => {
            dispatch({ type: POSTATRIBUTOADDNEW, payload: dados });
            dispatch({ type: POSTATRIBUTOADDNEWLOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const setAtributoSelecionado = (atributo) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: SET_ATRIBUTO_SELECIONADO, payload: atributo });
    });

export const getAtriutoAplicarListAction = (sku, produto, categoria, atributoid, atributovalor) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: ATRIBUTOSAPLICARLISTLOADING, payload: true });
        Api.gettAtributoAplicarList(sku, produto, categoria, atributoid, atributovalor).then(dados => {
            dispatch({ type: ATRIBUTOSAPLICARLIST, payload: dados });
            dispatch({ type: ATRIBUTOSAPLICARLISTLOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const getAtributoGeralAction = (sku, produto, categoria, atributovalor, atributoid) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: ATRIBUTOSAPLICARGERALLOADING, payload: true });
        Api.getAtributoAplicarGeral(sku, produto, categoria, atributovalor, atributoid).then(dados => {
            dispatch({ type: ATRIBUTOSAPLICARGERAL, payload: dados });
            dispatch({ type: ATRIBUTOSAPLICARGERALLOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const getAtributoDeleteAction = (sku, atributovalorid) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: ATRIBUTOSAPLICARDELETELOADING, payload: true });
        Api.getAtributoAplicarDelete(sku, atributovalorid).then(dados => {
            dispatch({ type: ATRIBUTOSAPLICARDELETE, payload: dados });
            dispatch({ type: ATRIBUTOSAPLICARDELETELOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const getAtributoUpdateAction = (dados) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: ATRIBUTOSAPLICAREDITLOADING, payload: true });
        Api.getAtributoAplicarUpdate(dados).then(dados => {
            dispatch({ type: ATRIBUTOSAPLICAREDIT, payload: dados });
            dispatch({ type: ATRIBUTOSAPLICAREDITLOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const getFabricanteListAction = (dados) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: FABRICANTELISTLOADING, payload: true });
        Api.getFabricanteList().then(dados => {
            dispatch({ type: FABRICANTELIST, payload: dados });
            dispatch({ type: FABRICANTELISTLOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const postFabricanteNewAction = (tecafabricante) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: POSTATRIBUTOADDNEWLOADING, payload: true });
        Api.postFabricanteNew(tecafabricante).then(dados => {
            dispatch({ type: POSTATRIBUTOADDNEW, payload: dados });
            dispatch({ type: POSTATRIBUTOADDNEWLOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const editFabricanteAction = (tecafabricanteid, tecafabricante) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: EDITATRIBUTOLOADING, payload: true });
        Api.editFabricante(tecafabricanteid, tecafabricante).then(dados => {
            dispatch({ type: EDITATRIBUTO, payload: dados });
            dispatch({ type: EDITATRIBUTOLOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const deleteFabricanteAction = (tecafabricanteid) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: DELETEATRIBUTOLOADING, payload: true });
        Api.deleteFabricante(tecafabricanteid).then(dados => {
            dispatch({ type: DELETEATRIBUTO, payload: dados });
            dispatch({ type: DELETEATRIBUTOLOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const getClassificacaoListAction = (dados) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: CLASSIFICACAOLISTLOADING, payload: true });
        Api.getClassificacaoList().then(dados => {
            dispatch({ type: CLASSIFICACAOLIST, payload: dados });
            dispatch({ type: CLASSIFICACAOLISTLOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const postClassificacaoNewAction = (classificacao, plural) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: POSTATRIBUTOADDNEWLOADING, payload: true });
        Api.postClassificacaoNew(classificacao, plural).then(dados => {
            dispatch({ type: POSTATRIBUTOADDNEW, payload: dados });
            dispatch({ type: POSTATRIBUTOADDNEWLOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const editClassificacaoAction = (classificacaoid, classificacao, plural) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: EDITATRIBUTOLOADING, payload: true });
        Api.editClassificacao(classificacaoid, classificacao, plural).then(dados => {
            dispatch({ type: EDITATRIBUTO, payload: dados });
            dispatch({ type: EDITATRIBUTOLOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const deleteClassificacaoAction = (classificacaoid) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: DELETEATRIBUTOLOADING, payload: true });
        Api.deleteClassificacao(classificacaoid).then(dados => {
            dispatch({ type: DELETEATRIBUTO, payload: dados });
            dispatch({ type: DELETEATRIBUTOLOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const getMarcaListAction = (dados) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: MARCALISTLOADING, payload: true });
        Api.getMarcaList(dados).then(dados => {
            dispatch({ type: MARCALIST, payload: dados });
            dispatch({ type: MARCALISTLOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const postMarcaNewAction = (tecafabricanteid, tecamarca) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: POSTATRIBUTOADDNEWLOADING, payload: true });
        Api.postMarcaNew(tecafabricanteid, tecamarca).then(dados => {
            dispatch({ type: POSTATRIBUTOADDNEW, payload: dados });
            dispatch({ type: POSTATRIBUTOADDNEWLOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const editMarcaAction = (tecamarcaid, tecafabricanteid, tecamarca) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: EDITATRIBUTOLOADING, payload: true });
        Api.editMarca(tecamarcaid, tecafabricanteid, tecamarca).then(dados => {
            dispatch({ type: EDITATRIBUTO, payload: dados });
            dispatch({ type: EDITATRIBUTOLOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const deleteMarcaAction = (tecamarcaid) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: DELETEATRIBUTOLOADING, payload: true });
        Api.deleteMarca(tecamarcaid).then(dados => {
            dispatch({ type: DELETEATRIBUTO, payload: dados });
            dispatch({ type: DELETEATRIBUTOLOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const getLinhaListAction = (dados) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: LINHALISTLOADING, payload: true });
        Api.getLinhaList(dados).then(dados => {
            dispatch({ type: LINHALIST, payload: dados });
            dispatch({ type: LINHALISTLOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const postLinhaNewAction = (tecamarcaid, tecalinha) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: POSTATRIBUTOADDNEWLOADING, payload: true });
        Api.postLinhaNew(tecamarcaid, tecalinha).then(dados => {
            dispatch({ type: POSTATRIBUTOADDNEW, payload: dados });
            dispatch({ type: POSTATRIBUTOADDNEWLOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const editLinhaAction = (tecalinhaid, tecamarcaid, tecalinha) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: EDITATRIBUTOLOADING, payload: true });
        Api.editLinha(tecalinhaid, tecamarcaid, tecalinha).then(dados => {
            dispatch({ type: EDITATRIBUTO, payload: dados });
            dispatch({ type: EDITATRIBUTOLOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const deleteLinhaAction = (tecalinhaid) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: DELETEATRIBUTOLOADING, payload: true });
        Api.deleteLinha(tecalinhaid).then(dados => {
            dispatch({ type: DELETEATRIBUTO, payload: dados });
            dispatch({ type: DELETEATRIBUTOLOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const getSecaoListAction = () => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: SECAOLISTLOADING, payload: true });
        Api.getSecaoList().then(dados => {
            dispatch({ type: SECAOLIST, payload: dados });
            dispatch({ type: SECAOLISTLOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const getSecaoSKUListAction = (dados) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: SECAOSKULISTLOADING, payload: true });
        Api.getSecaoSKUList(dados).then(dados => {
            dispatch({ type: SECAOSKULIST, payload: dados });
            dispatch({ type: SECAOSKULISTLOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const getBuscaSKUAction = (dados) => (dispatch) =>
    new Promise(function (resolve, reject) {
        const skuBusca = dados;
        dispatch({ type: BUSCASKULOADING, payload: true });
        Api.getBuscaSKU(dados).then(dados => {
            dispatch({ type: BUSCASKULASTSKU, payload: skuBusca });
            dispatch({ type: BUSCASKU, payload: dados });
            dispatch({ type: BUSCASKULOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            dispatch({ type: BUSCASKULOADING, payload: false });
            reject(error);
        })
    });

export const getConteudoListAction = (dados) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: CONTEUDOLISTLOADING, payload: true });
        Api.getConteudoList(dados).then(dados => {
            dispatch({ type: CONTEUDOLIST, payload: dados });
            dispatch({ type: CONTEUDOLISTLOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const getConteudoDetalhesAction = (dados) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: CONTEUDODETALHESLOADING, payload: true });
        Api.getConteudoDetalhes(dados).then(dados => {
            dispatch({ type: CONTEUDODETALHES, payload: dados });
            dispatch({ type: CONTEUDODETALHESLOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const getConteudoBuscaAction = (dados) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: CONTEUDOBUSCALOADING, payload: true });
        Api.getConteudoBusca(dados).then(dados => {
            dispatch({ type: CONTEUDOBUSCA, payload: dados });
            dispatch({ type: CONTEUDOBUSCALOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });


export const getAplicarEstAction = (dados) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: APLICARESTLISTLOADING, payload: true });
        Api.getAplicarEstList(dados).then(dados => {
            dispatch({ type: APLICARESTLIST, payload: dados });
            dispatch({ type: APLICARESTLISTLOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const getAplicarEstBuscaAction = (dados) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: APLICARESTBUSCALISTLOADING, payload: true });
        Api.getAplicarEstBusca(dados).then(dados => {
            dispatch({ type: APLICARESTBUSCALIST, payload: dados });
            dispatch({ type: APLICARESTBUSCALISTLOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const postAplicarEstAplicaAction = (dados) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: APLICARESTAPLICALOADING, payload: true });
        Api.postAplicarEstAplica(dados).then(dados => {
            dispatch({ type: APLICARESTAPLICA, payload: dados });
            dispatch({ type: APLICARESTAPLICALOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            dispatch({ type: APLICARESTAPLICALOADING, payload: false });
            reject(error);
        })
    });

export const getConteudoAplicaAction = (dados) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: CONTEUDOAPLICALOADING, payload: true });
        Api.getConteudoBusca(dados).then(dados => {
            dispatch({ type: CONTEUDOAPLICA, payload: dados });
            dispatch({ type: CONTEUDOAPLICALOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const postUpdateDescConteudo = (dados) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: UPDATEDESCCONTEUDOLOADING, payload: true });
        Api.postUpdateDescConteudo(dados).then(dados => {
            dispatch({ type: UPDATEDESCCONTEUDO, payload: dados });
            dispatch({ type: UPDATEDESCCONTEUDOLOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const postUpdateTituloConteudo = (dados) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: UPDATETITULOCONTEUDOLOADING, payload: true });
        Api.postUpdateTituloConteudo(dados).then(dados => {
            dispatch({ type: UPDATETITULOCONTEUDO, payload: dados });
            dispatch({ type: UPDATETITULOCONTEUDOLOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const postNewTitulo = (dados) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: ADDTITULOCONTEUDOLOADING, payload: true });
        Api.postAdicionaTituloConteudo(dados).then(dados => {
            dispatch({ type: ADDTITULOCONTEUDO, payload: dados });
            dispatch({ type: ADDTITULOCONTEUDOLOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });

export const postDeleteTitulo = (dados) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: DELETETITULOCONTEUDOLOADING, payload: true });
        Api.postExcluiTituloConteudo(dados).then(dados => {
            dispatch({ type: DELETETITULOCONTEUDO, payload: dados });
            dispatch({ type: DELETETITULOCONTEUDOLOADING, payload: false });
            resolve(dados)
        }).catch(error => {
            reject(error);
        })
    });
